import { Component } from '@angular/core';

import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { IconComponent, type IconName } from '@core/user-interface-legacy';
import type { AskTicketStatus } from '@tellent-ask-hr/tickets-types';
import { injectStatusTranslations, statusIconMap } from '@tellent-ask-hr/tickets-util';

import { AsksColumnId, defineAskTableColumn } from '../../ask-tickets-view/columns/types';

/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/consistent-type-assertions */

@Component({
  selector: 'ask-hr-status',
  template: `
    <rt-icon [name]="statusIconMap[status]" margin-right-small-xx />
    <span>{{ statusTranslations[status] }}</span>
  `,
  host: {
    layout: '',
  },
  inputs: StatusComponent.NgInputs,
  imports: [IconComponent],
})
export class StatusComponent {
  public static NgInputs = ['status' as const];

  protected readonly statusIconMap: Record<AskTicketStatus, IconName> = statusIconMap;
  protected readonly statusTranslations: Record<AskTicketStatus, string> =
    injectStatusTranslations();

  public status: AskTicketStatus;
}

export const statusUserColumn = defineAskTableColumn(() => ({
  id: AsksColumnId.Status,
  label: injectTranslate()('tlc.ask_hr.requests.status'),
  visible: true,
  geometry: {
    width: 244,
    minWidth: 150,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: false,
    removable: false,
    sortable: true,
  },
  componentFactory: ({ row }) =>
    componentOutletConfigFactory(StatusComponent, {
      inputs: {
        status: row.status,
      },
    }),
}));
